import { Component, inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface IDowloaingDialogData {
  title: string;
  message: string;
}

@Component({
  selector: 'app-loading-dialog',
  templateUrl: './loading-dialog.component.html',
  styleUrls: ['./loading-dialog.component.scss'],
  standalone: false
})
export class LoadingDialogComponent {
  dialogRef = inject<MatDialogRef<LoadingDialogComponent>>(MatDialogRef);
  data = inject<IDowloaingDialogData>(MAT_DIALOG_DATA);
}
